module.exports = __webpack_public_path__ + "img/logo-pinosvl-v2.299ca9ba.png";